
import { Box, Container } from "@mui/material";
import CardServices from "../cardServices";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import RegisterAccess from '../../../utils/registerAccess';


interface MenuState {
  solicitacoesImportacao: number;
  analisado: number;
  deferido: number;
  chefeSeccao: number;
  chefeDepartamento: number;
  directorGeral: number;
  reclamacoes: number;
  quota: number;
  certificadosEmitidos: number; 
  reprovado: number; 
}

type MenuProps = {
  styles: string
}

export default function MenuDmtsCertificadoProdutoControlado({ styles }: MenuProps) {
  // const user = useSelector(state => state.account.user);

  const [menu, setMenu] = useState<MenuState>({
    solicitacoesImportacao: 0,
    analisado: 0,
    deferido: 0,
    reclamacoes: 0,
    quota: 0,

    chefeSeccao: 0,
    chefeDepartamento: 0,
    directorGeral: 0,
    certificadosEmitidos: 0,
    reprovado: 0,

  })
  const [loadMenu, setLoadMenu] = useState<boolean>(true)


  useEffect(() => {
    api.get(`/menu/certificadoProdutoControlado`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  return (
    <Container>
      <RegisterAccess page={'menu certificados para importacao de produto controlado'} />

      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.solicitacoesImportacao} icone={'/icones/Licenciamento.svg'} nomeService={'Solicitações de Certificado'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Análise'} />
        <CardServices funcao='Técnico' load={loadMenu} count={menu.reprovado} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Solicitações Reprovadas'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Reprovado'} />
        {/* <CardServices load={loadMenu} count={menu.quota} icone={''} nomeService={'Gestão de Quota'} link={'/admin/dmts/gest/quota'} /> */}
        {/* <CardServices load={loadMenu} count={menu.reclamacoes} icone={'/icones/Reclamacoes.svg'} nomeService={'Reclamações'} link={'/admin/reclamacoes?page=1'} /> */}
      </Box>


      <Box className={styles}>
        {/* <CardServices funcao='Chefe de Secção' load={loadMenu} count={menu.chefeSeccao} icone={'/icones/chefedaSeccao.svg'} nomeService={'Chefe de Secção'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/chefe-da-seccao'} /> */}
        <CardServices funcao='Chefe de Departamento' load={loadMenu} count={menu.analisado} icone={'/icones/chefeDepartamento.svg'} nomeService={'Chefe de Departamento'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Analisado'} />
        <CardServices funcao='Director Geral' load={loadMenu} count={menu.deferido} icone={'/icones/diretoraGeral.svg'} nomeService={'Diretor(a) Geral'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Deferimento'} />
        <CardServices funcao='' load={loadMenu} count={menu.certificadosEmitidos} icone={'/icones/controleQualidade/certificadosAutorizacoes.svg'} nomeService={'Certificados Emitidos'} link={'/admin/dmts/solicitacoes-de-importacao/produtos/Controlados/Aprovado'} />
      </Box>
    </Container>
  )
}





